import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import ScrollToTop from './ScrollToTop';
import ParticleBackground from '../ParticleBackground';

const Layout = () => {
  return (
    <div className="min-h-screen" style={{ position: 'relative' }}>
      <ParticleBackground />
      <ScrollToTop />
      <Navbar />
      <main className="relative" style={{ zIndex: 1 }}>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default Layout;